import { manageAdminConstant } from 'Constants/manageAdmin.constants';
import Request from 'Services/request';
import { manageAdminRolesActions } from './manageAdminRolesactions'
import { alterQueryRequest,  findCurrentPageRequest, queryParser } from 'Helpers/urlform'
import { toast as toastr } from 'react-toastify';
import { dateAndTimeFormat, handleApiError } from 'Helpers/index';

const requestAdminUser = manageAdmin =>({ 
    type: manageAdminConstant.ADMIN_USER_REQUEST, 
    manageAdmin 
})
const requestAdminUserForm = manageAdmin =>({ 
  type: manageAdminConstant.ADMIN_USER_FORM_REQUEST, 
  manageAdmin 
})

const successAdminUser = adminDetails =>({
    type: manageAdminConstant.ADMIN_USER_GET_SUCCESS,
    manageAdmin:adminDetails.data,
    totalRecords:adminDetails.count,
    currentPage:adminDetails.currentPage
})

const successUpdateAdminUser = adminDetails =>({
  type: manageAdminConstant.UPDATE_ADMIN_USER_SUCCESS,
  manageAdmin:adminDetails
})

const failureAddminUserForm = error =>({
  type: manageAdminConstant.ADMIN_USER_FORM_FAILURE,
  error
})
const failureEditAddminUserForm = error =>({
  type: manageAdminConstant.ADMIN_USER_EDIT_FORM_FAILURE,
  error
})

const failureAddminUser = error =>({
    type: manageAdminConstant.ADMIN_USER_FAILURE,
    error
})

function fetchAdminUser(SearchArray) {
  let url = '/adminuser';
  if(SearchArray && SearchArray.length > 0 ) {
    url = queryParser(url,SearchArray);
  }  
  const currentPage = findCurrentPageRequest(SearchArray);
  return async (dispatch) => {
    dispatch(requestAdminUser({}));
    await Request.get(url, {})
      .then(( response ) => {
        const { data,count } = response;
        dispatch(successAdminUser({ data, count, currentPage }));
        dispatch(manageAdminRolesActions.fetchAlladminRoles());
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureAddminUser(error.toString()));
        }
      });
  };
}

function addAdminUser(addAdminUserObj,SearchArray) {
  return (dispatch) => {
    dispatch(requestAdminUserForm({}));
    Request.create('/adminuser',{ ...addAdminUserObj })
    .then((response) => {
      const {  message } = response;   
      dispatch(fetchAdminUser(SearchArray));
      toastr.dismiss();
      toastr.success(message);
    })
    .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureAddminUserForm(error.toString()));
        }
    });
  };
}

function updateAdminUser(adminUserObj, SearchArray) {
  const { id, ...rest } = adminUserObj
  return (dispatch) => {
    dispatch(requestAdminUserForm({}));
    Request.update(`/adminuser/${ id }`,
      { ...rest })
      .then((response) => {
        const { message } = response;        
        dispatch(successUpdateAdminUser(adminUserObj));
        dispatch(fetchAdminUser(SearchArray));
        dispatch(exportAdmin(SearchArray));
        // toastr.dismiss();
        toastr.success(message);
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureEditAddminUserForm(error.toString()));
        }
      });
  };
}

function deleteAdminUser(id, SearchArray, remainningRecords,currentPage){
  const updateSearchArray = alterQueryRequest(SearchArray, remainningRecords,currentPage);
    return (dispatch) => {
        dispatch(requestAdminUser({}));
        Request.remove('/adminuser',
        { id: id  })
        .then(() => {
          return dispatch(fetchAdminUser(updateSearchArray));
        }).then(()=>{
          toastr.dismiss();
            toastr.success('Admin User deleted Successfully')
        })
        .catch((error) => {
          if(error) {
            handleApiError(error);
            dispatch(failureAddminUser(error.toString()));
          }
        });
    }
}

const requestAdminExportData = exportData => ({
    type: manageAdminConstant.EXPORT_ADMIN_REQUEST,
    exportData
})

const successAdminExportData = exportDataObj => ({
    type: manageAdminConstant.EXPORT_ADMIN_SUCCESS,
    exportData: exportDataObj.data,
    totalRecords: exportDataObj.count
})

const failureAdminExportData = error => ({
    type: manageAdminConstant.EXPORT_ADMIN_FAILURE,
    error
})

function exportAdmin(SearchArray) {
    let url = '/adminuser';
    if (SearchArray && SearchArray.length > 0) {
      url = queryParser(url, SearchArray);
    }
    const exportUrl = SearchArray && SearchArray.length > 0 ? `&exportType=true` : `?exportType=true`;

    url = `${ url }${ exportUrl }`;
    return async (dispatch) => {
        dispatch(requestAdminExportData({}));
        await Request.get(url, {})
            .then(response => {
                const { data: resData = [], count = 10 } = response;
                const data = resData.map(function(res){
                  const obj = {};
                  obj[ 'Name' ] = res.name; 
                  obj[ 'Email' ] = res.emailId;
                  obj[ 'Access Level' ] = res.accessLevel;
                  obj[ 'Status' ] = res.isActive === 0 ? 'In Active' : 'Active';
                  const createAt = dateAndTimeFormat(res.createdAt);
                  const updateAt = dateAndTimeFormat(res.updatedAt);
                  obj[ 'Created Date' ] = createAt;
                  obj[ 'Updated Date' ] = updateAt;
                  return obj;
                });
                dispatch(successAdminExportData({ data, count }));
            })
            .catch((error) => {
                if(error) {
                  handleApiError(error);
                  dispatch(failureAdminExportData(error.toString()));
                }
            });
    };
}
  
export const manageAdminActions = {
  fetchAdminUser,
  addAdminUser,
  updateAdminUser,
  deleteAdminUser,
  exportAdmin,
};